export const CROATIAN_LOCATIVES: Record<string, string> = {
  "Rovinj": "Rovinju",
  "Zlatni Rat": "Zlatnom Ratu",
  "Plitvice Lakes": "Plitvičkim jezerima",
  "Zagreb": "Zagrebu",
  "Pula": "Puli",
  "Poreč": "Poreču",
  "Dubrovnik": "Dubrovniku",
  "Split": "Splitu",
  "Hvar": "Hvaru",
  "Makarska": "Makarskoj",
  "Zadar": "Zadru",
  "Opatija": "Opatiji",
  "Rab": "Rabu",
  "Baška": "Baškoj",
  "Malinska": "Malinskoj",
  "Krk Town": "Gradu Krku",
  "Biograd na Moru": "Biogradu na Moru",
  "Medulin": "Medulinu",
  "Trogir": "Trogiru",
  "Rijeka": "Rijeci",
  "Varaždin": "Varaždinu",
  "Osijek": "Osijeku",
  "Umag": "Umagu",
  "Mali Lošinj": "Malom Lošinju",
  "Crikvenica": "Crikvenici",
  "Vodice": "Vodicama",
  "Šibenik": "Šibeniku",
  "Korčula Town": "Gradu Korčuli",
  "Novalja": "Novalji",
  "Supetar": "Supetru",
  "Nin": "Ninu",
  "Omiš": "Omišu",
  "Cavtat": "Cavtatu",
  "Primošten": "Primoštenu",
  "Rabac": "Rabacu",
  "Baška Voda": "Baškoj Vodi",
  "Tučepi": "Tučepima",
  "Podgora": "Podgori",
  "Gradac": "Gracu",
  "Starigrad Paklenica": "Starigradu Paklenica",
  "Novigrad": "Novigradu",
  "Vrsar": "Vrsaru",
  "Funtana": "Funtani",
  "Tar-Vabriga": "Tar-Vabrigi",
  "Labin": "Labinu",
  "Pazin": "Pazinu",
  "Lovran": "Lovranu",
  "Mošćenička Draga": "Mošćeničkoj Dragi",
  "Ičići": "Ičićima",
  "Kastav": "Kastavu",
  "Senj": "Senju",
  "Karlobag": "Karlobagu",
  "Novi Vinodolski": "Novom Vinodolskom",
  "Selce": "Selcu",
  "Kraljevica": "Kraljevici",
  "Bakar": "Bakru",
  "Omišalj": "Omišlju",
  "Punat": "Punatu",
  "Ston": "Stonu",
  "Dobrinj": "Dobrnju",
  "Vela Luka": "Veloj Luci",
  "Lumbarda": "Lumbardi",
  "Stari Grad": "Starom Gradu",
  "Jelsa": "Jelsi",
  "Komiža": "Komiži",
  "Vis": "Visu",
  "Orebić": "Orebiću",
  "Trpanj": "Trpnju",
  "Njivice": "Njivicama",
  "Rogoznica": "Rogoznici",
  "Marina": "Marini",
  "Kaštela": "Kaštelama",
  "Solin": "Solinu",
  "Klis": "Klisu",
  "Sinj": "Sinju",
  "Imotski": "Imotskom",
  "Vrgorac": "Vrgorca",
  "Metković": "Metkoviću",
  "Opuzen": "Opuzenu",
  "Slano": "Slanom",
  "Mlini": "Mlinima",
  "Plat": "Platu",
  "Murter": "Murteru",
  "Tisno": "Tisnom",
  "Betina": "Betini",
  "Jezera": "Jezerima",
  "Tribunj": "Tribunju",
  "Ploče": "Pločama",
  "Drniš": "Drnišu",
  "Skradin": "Skradinu",
  "Knin": "Kninu",
  "Gospić": "Gospiću",
  "Otočac": "Otočcu",
  "Ogulin": "Ogulinu",
  "Karlovac": "Karlovcu",
  "Samobor": "Samoboru",
  "Čakovec": "Čakovcu",
  "Vukovar": "Vukovaru",
  "Vinkovci": "Vinkovcima",
  "Slavonski Brod": "Slavonskom Brodu",
  "Požega": "Požegi",
  "Đakovo": "Đakovu",
  "Ilok": "Iloku",
  "Našice": "Našicama",
  "Bjelovar": "Bjelovaru",
  "Koprivnica": "Koprivnici",
  "Križevci": "Križevcima",
  "Sisak": "Sisku",
  "Petrinja": "Petrinji",
  "Kutina": "Kutini",
  "Daruvar": "Daruvaru",
  "Lipik": "Lipiku",
  "Pakrac": "Pakracu",
  "Glina": "Glini",
  "Slunj": "Slunju",
  "Rastoke": "Rastokama",
  "Korenica": "Korenici",
  "Gračac": "Gračacu",
  "Kolan": "Kolanu",
  "Povljana": "Povljani",
  "Lopar": "Loparu",
  "Kampor": "Kamporu",
  "Supetarska Draga": "Supetarskoj Dragi",
  "Vrbnik": "Vrbniku",
  "Šilo": "Šilu",
  "Baška Draga": "Baškoj Dragi",
  "Stara Baška": "Staroj Baškoj",
  "Cres": "Cresu",
  "Valun": "Valunu",
  "Lubenice": "Lubenicama",
  "Martinšćica": "Martinšćici",
  "Nerezine": "Nerezinama",
  "Veli Lošinj": "Velom Lošinju",
  "Ilovik": "Iloviku",
  "Susak": "Susaku",
  "Unije": "Unijama",
  "Silba": "Silbi",
  "Olib": "Olibu",
  "Premuda": "Premudi",
  "Molat": "Molatu",
  "Ist": "Istu",
  "Dugi Otok": "Dugom Otoku",
  "Sali": "Salima",
  "Božava": "Božavi",
  "Veli Rat": "Velom Ratu",
  "Zaton (Zadar)": "Zatonu (Zadar)",
  "Petrčane": "Petrčanima",
  "Privlaka": "Privlaci",
  "Vir": "Viru",
  "Vrsi": "Vrsima",
  "Zablaće": "Zablaću",
  "Jadrija": "Jadriji",
  "Brodarica": "Brodarici",
  "Grebaštica": "Grebaštici",
  "Primošten Burnji": "Primoštenu Burnjom",
  "Sevid": "Sevidu",
  "Kanica": "Kanici",
  "Ražanj": "Ražnju",
  "Podstrana": "Podstrani",
  "Dugi Rat": "Dugom Ratu",
  "Jesenice": "Jesenicama",
  "Krilo": "Krilu",
  "Lokva Rogoznica": "Lokvi Rogoznici",
  "Pisak": "Pisku",
  "Marušići": "Marušićima",
  "Mimice": "Mimicama",
  "Igrane": "Igranama",
  "Zaostrog": "Zaostrošu",
  "Drvenik": "Drveniku",
  "Brna": "Brnoj",
  "Smokvica": "Smokvici",
  "Blato": "Blatu",
  "Račišće": "Račišću",
  "Kneža": "Kneži",
  "Zaton (Dubrovnik)": "Zatonu (Dubrovnik)",
  "Trsteno": "Trstenom",
  "Brsečine": "Brsečinama",
  "Koločep": "Koločepu",
  "Lopud": "Lopudu",
  "Šipan": "Šipanu",
  "Delnice": "Delnicama",
  "Brod na Kupi": "Brodu na Kupi",
  "Brela": "Brelima",
  "Krapina": "Krapini",
  "Zabok": "Zaboku",
  "Zaprešić": "Zaprešiću",
  "Virovitica": "Virovitici",
  "Đurđevac": "Đurđevcu",
  "Tuhelj": "Tuheljima",
  "Mrkopalj": "Mrkopalju",
  "Fužine": "Fužinama",
  "Ozalj": "Ozlju",
  "Jastrebarsko": "Jastrebarskom",
  "Udbina": "Udbini",
  "Trilj": "Trilju",
  "Milna": "Milnoj",
  "Pučišća": "Pučišćima",
  "Sumartin": "Sumartinu",
  "Bol": "Bolu",
  "Sućuraj": "Sućuraju",
  "Lika and Gorski Kotar": "Lici i Gorskom kotaru",
  "Slavonia": "Slavoniji",
  "Dalmatia": "Dalmaciji",
  "Kvarner": "Kvarneru",
  "Istria": "Istri",
  "Central Croatia": "Središnjoj Hrvatskoj",
};

export function getCroatianLocative(name: string): string {
  return CROATIAN_LOCATIVES[name] ?? name;
}
